//#region src/utils/noop.ts
function noop() {}
//#endregion
export { noop };

//# sourceMappingURL=noop.js.map